<template>
    <div>
        <div :class="{ 'show': modalShow }" class="modal fade">
            <form>
                <!-- <form @submit.prevent="submitFormData"> -->
                <div class="modal-dialog modal-xl modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header border-bottom">
                            <h5 class="modal-title h4 text-capitalize">{{ (skuID ? $t('header.edit') : $t('header.add')) +
                                $t('subMenu.salon_menu_product') }}
                                <small v-if="skuID" class="m-0 text-muted">{{ $t('subMenu.salon_menu_product') }} - "{{ name }}"</small>
                            </h5>
                            <button type="button" class="close" @click="modalShow = false">
                                <span aria-hidden="true"><i class="fal fa-times"></i></span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <ul class="nav nav-tabs" role="tablist">
                                <li class="nav-item" v-for="c in $i18n.messages[$i18n.locale].tab.itemFormTabsProduct" :key="c.id">
                                    <a :class="{ 'active': selectedTab == c.id }" class="nav-link" role="tab" @click="selectedTab = c.id">{{ c.text }}</a>
                                </li>
                            </ul>
                            <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                                <b-spinner label="Loading..."></b-spinner>
                            </div>
                            <div v-if="!isSpinnerShow" class="tab-content">
                                <div :class="{ 'active': selectedTab == 'details' }" class="tab-pane mt-3">
                                    <div class="row">
                                        <div class="col-sm-12 col-md-6 border-right">
                                            <div class="form-group">
                                                <label class="form-label">{{ $t('label.name') }}</label>
                                                <div class="input-group bg-white shadow-inset-2">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text bg-transparent border-right-0">
                                                            <i class="fas fa-text"></i>
                                                        </span>
                                                    </div>
                                                    <input
                                                        id="input-name"
                                                        type="text"
                                                        class="form-control bg-transparent pl-3"
                                                        :class="showNameError && nameError ? 'error-class' : ''"
                                                        :placeholder="$t('label.title')"
                                                        @keyup="keydownName($event)"
                                                        v-model="name"
                                                        required="">
                                                </div>
                                                <label v-if="showNameError && nameError" for="input-name" class="error-class" style="" v-html="nameError">
                                                </label>
                                                <label v-if="nameDuplicateError" for="input-name" class="info-class" style="" v-html="nameDuplicateError">
                                                </label>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-sm-12 col-md-6">
                                                    <div class="form-group">
                                                        <label class="form-label">{{ $t('label.price') }}</label>
                                                        <div class="input-group bg-white shadow-inset-2">
                                                            <div class="input-group-prepend">
                                                                <span class="input-group-text bg-transparent border-right-0">
                                                                    <i class="fas fa-dollar-sign"></i>
                                                                </span>
                                                            </div>
                                                            <input
                                                                id="input-price"
                                                                type="number"
                                                                class="form-control bg-transparent pl-3"
                                                                :class="showPriceError && priceError ? 'error-class' : ''"
                                                                :placeholder="$t('label.price')"
                                                                @keydown="keydownPrice($event)"
                                                                @keyup="keyupPrice($event)"
                                                                v-model="price"
                                                                required="">
                                                        </div>
                                                        <label v-if="showPriceError && priceError" for="input-price" class="error-class" style="">{{
                                                            priceError }}</label>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-6">
                                                    <div class="form-group">
                                                        <label class="form-label">{{ $t('label.base_price') }}</label>
                                                        <div class="input-group bg-white shadow-inset-2">
                                                            <div class="input-group-prepend">
                                                                <span class="input-group-text bg-transparent border-right-0">
                                                                    <i class="fas fa-dollar-sign"></i>
                                                                </span>
                                                            </div>
                                                            <input
                                                                id="input-base-price"
                                                                type="number"
                                                                class="form-control bg-transparent pl-3"
                                                                :class="showBasePriceError && basePriceError ? 'error-class' : ''"
                                                                :placeholder="$t('label.base_price')"
                                                                @keydown="keypressBasePrice($event)"
                                                                v-model="basePrice"
                                                                required="">
                                                        </div>
                                                        <label v-if="showBasePriceError && basePriceError" for="input-price" class="error-class"
                                                            style="">{{ basePriceError
                                                            }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="false" class="form-group">
                                                <label class="form-label">{{ $t('label.duration') }}</label>
                                                <div class="input-group bg-white shadow-inset-2">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text bg-transparent border-right-0">
                                                            <i class="fas fa-clock"></i>
                                                        </span>
                                                    </div>
                                                    <vue-timepicker
                                                        class="form-control bg-transparent pt-1"
                                                        :format="'H hr mm Min'"
                                                        :hide-disabled-hours="true"
                                                        :hour-range="hourRange"
                                                        :minute-range="minuteRange"
                                                        :minute-interval="15"
                                                        v-model="duration"
                                                        @open="updateTimePicker()"
                                                        @change="updateTimePicker()">
                                                    </vue-timepicker>
                                                </div>
                                                <div id="err" class="error-validation"></div>
                                            </div>
                                            <div class="row mb-3">
                                                <div class="col-sm-12 col-md-6">
                                                    <div class="form-group">
                                                        <label class="form-label">Unit</label>
                                                        <multiselect
                                                            v-model="unit"
                                                            :options="units"
                                                            label="name"
                                                            track-by="unit"
                                                            :searchable="true"
                                                            :show-labels="false"
                                                            openDirection="below">
                                                            <template slot="option" slot-scope="{ option }"> {{ option.name }}</template>
                                                        </multiselect>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-6">
                                                    <div class="form-group">
                                                        <label class="form-label">Ingredient</label>
                                                        <multiselect
                                                            v-model="ingredient"
                                                            :options="units"
                                                            label="name"
                                                            track-by="unit"
                                                            :searchable="true"
                                                            :show-labels="false"
                                                            openDirection="below">
                                                            <template slot="option" slot-scope="{ option }"> {{ option.name }}</template>
                                                        </multiselect>
                                                    </div>
                                                </div>
                                            </div>
                                            <label class="form-label">Stock Alert</label>
                                            <div class="row mb-3">
                                                <div class="col-sm-12 col-md-6">
                                                    <div class="form-group">
                                                        <label class="form-label">Low</label>
                                                        <input
                                                            type="number"
                                                            class="form-control bg-transparent pl-3"
                                                            v-model="stockAlertLow">
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-6">
                                                    <div class="form-group">
                                                        <label class="form-label">High</label>
                                                        <input
                                                            type="number"
                                                            class="form-control bg-transparent pl-3"
                                                            v-model="stockAlertHigh">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6">
                                            <div class="form-group">
                                                <label class="form-label">{{ $t('label.category') }}</label>
                                                <div class="input-group">
                                                    <div class="input-group-prepend w-100">
                                                        <label class="input-group-text border-right-0">
                                                            <i class="fas fa-tag"></i>
                                                        </label>
                                                        <multiselect
                                                            :value="selectedCategory"
                                                            :options="categories"
                                                            label="name"
                                                            track-by="sectionID"
                                                            :searchable="false"
                                                            :show-labels="false"
                                                            openDirection="below"
                                                            @select="filterSubCatByCategory">
                                                            <template slot="option" slot-scope="{ option }">
                                                                {{ option.name }}
                                                            </template>
                                                        </multiselect>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">{{ $t('label.subcategory') }}</label>
                                                <div class="input-group">
                                                    <div class="input-group-prepend w-100">
                                                        <label class="input-group-text border-right-0">
                                                            <i class="fas fa-tags"></i>
                                                        </label>
                                                        <multiselect
                                                            :value="selectedSubcategory"
                                                            :options="subCategory"
                                                            track-by="folderID"
                                                            label="name"
                                                            :show-labels="false"
                                                            openDirection="below"
                                                            @select="selectSubcategory">
                                                            <span slot="noResult">{{ $t('table.no_records') }}</span>
                                                            <template slot="option" slot-scope="{ option }">
                                                                {{ option.name }}
                                                            </template>
                                                        </multiselect>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div class="form-group mb-2">
                                                <div class="custom-control custom-switch">
                                                    <input type="checkbox" class="custom-control-input" id="edititemEnable" v-model="enable">
                                                    <label class="custom-control-label" for="edititemEnable">{{ $t('label.enable') }}</label>
                                                </div>
                                            </div> -->
                                            <!-- <div class="form-group">
                                                <div class="custom-control custom-switch">
                                                    <input type="checkbox" class="custom-control-input" id="edititemOnline" v-model="online">
                                                    <label class="custom-control-label" for="edititemOnline">{{ $t('label.online') }}</label>
                                                </div>
                                            </div> -->
                                            <h6 class="text-dark fw-500">{{ $t('table.header.image') }}:</h6>
                                            <div id="imageContainer" v-if="image != ''" class="text-center mt-3">
                                                <div class="text-right mb-2 mr-2">
                                                    <button v-show="!dzShow" class="btn btn-sm btn-outline-primary" type="button"
                                                        :title="$t('header.delete_image')"
                                                        @click="showDeleteImageModal">
                                                        <span class="fal fa-trash"></span>
                                                    </button>
                                                </div>
                                                <a @click="handleDropzone('img-thumbnail')" :title="$t('button_link.click_upload')" class="m-auto">
                                                    <img class="img-fluid img-thumbnail" :src="image" />
                                                </a>
                                            </div>
                                            <div v-else>
                                                <vue-dropzone
                                                    ref="dropzone"
                                                    class="text-center"
                                                    id="dropzoneAdd"
                                                    :options="dropOptions"
                                                    @vdropzone-success="dropzoneAdd"
                                                    @vdropzone-removed-file="dropzoneRemoved">
                                                </vue-dropzone>
                                            </div>
                                            <div v-if="dzShow" class="mt-2">
                                                <div class="row">
                                                    <div class="col">
                                                        <h6 class="text-dark fs-sm">{{ $t('header.upload_image') }}: </h6>
                                                    </div>
                                                    <div class="col text-right">
                                                        <a id="uploadCancel" class="cancel link" @click="handleDropzone('item-image')">
                                                            {{ $t('button_link.cancel') }}
                                                        </a>
                                                    </div>
                                                </div>
                                                <vue-dropzone ref="dropzone" class="text-center" id="dropzoneAdd" :options="dropOptions"
                                                    @vdropzone-success="dropzoneAdd"></vue-dropzone>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div :class="{ 'active': selectedTab == 'pricing' }" class="tab-pane mt-3">
                                    <div class="row">
                                        <!-- <div class="col-sm-12 col-md-6 mb-3">
                                            <div class="form-group">
                                                <label class="form-label">{{ $t('label.price') }}</label>
                                                <div class="input-group bg-white shadow-inset-2">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text bg-transparent border-right-0">
                                                            <i class="fas fa-dollar-sign"></i>
                                                        </span>
                                                    </div>
                                                    <input
                                                        id="input-price2"
                                                        type="number"
                                                        class="form-control bg-transparent pl-3"
                                                        :class="showPriceError && priceError ? 'error-class' : ''"
                                                        :placeholder="$t('label.base_price')"
                                                        @keypress="isNumber($event)"
                                                        @keydown="keypressPrice($event)"
                                                        v-model="price"
                                                        required="">
                                                </div>
                                                <label v-if="showPriceError && priceError" for="input-price2" class="error-class" style="">{{ priceError
                                                }}</label>
                                            </div>
                                        </div>
                                        <br> -->
                                        <div v-show="false" class="col-sm-12 mb-3">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" class="custom-control-input" id="outlet-price" v-model="outletPriceToggle">
                                                <label class="custom-control-label" for="outlet-price">Outlet Price</label>
                                            </div>
                                        </div>
                                        <div class="col-12" v-show="outletPriceToggle">
                                            <table class="table table-clean">
                                                <tr>
                                                    <th class="text-center"></th>
                                                    <th class="text-center">Price</th>
                                                    <th class="text-center">Min price</th>
                                                    <th class="text-center">Max Price</th>
                                                </tr>
                                                <tr v-for="outlet in outlets" :key="'outlet-price-' + outlet['id']">
                                                    <td class="align-middle">{{ outlet['city'] + (duplicateCity ? ' [' + outlet['username'] + ']' : '') }}
                                                    </td>
                                                    <td>
                                                        <input
                                                            :name="'outlet-price-selling-' + outlet['id']"
                                                            type="number"
                                                            class="form-control"
                                                            @keydown="isPositiveNumber($event)"
                                                            v-model="outletPrices[outlet['id']]['selling']"
                                                            @keyup="keyupOutletPrice(outlet['id'])" />
                                                        <label v-if="outletPrices[outlet['id']]['selling_error']" class="error-class">{{ outletPrices[outlet['id']]['selling_error'] }}</label>
                                                    </td>
                                                    <td>
                                                        <input
                                                            :name="'outlet-price-minimum-' + outlet['id']"
                                                            type="number"
                                                            class="form-control"
                                                            @keydown="isPositiveNumber($event)"
                                                            v-model="outletPrices[outlet['id']]['minimum']" />
                                                        <label v-if="outletPrices[outlet['id']]['minimum_error']" class="error-class">{{ outletPrices[outlet['id']]['minimum_error'] }}</label>
                                                    </td>
                                                    <td>
                                                        <input
                                                            :name="'outlet-price-maximum-' + outlet['id']"
                                                            type="number"
                                                            class="form-control"
                                                            @keydown="isPositiveNumber($event)"
                                                            v-model="outletPrices[outlet['id']]['maximum']" />
                                                        <label v-if="outletPrices[outlet['id']]['maximum_error']" class="error-class">{{ outletPrices[outlet['id']]['maximum_error'] }}</label>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="false" :class="{ 'active': selectedTab == 'duration' }" class="tab-pane mt-3">
                                    <div class="row">
                                        <!-- <div class="col-sm-12 col-md-6 mb-3">
                                            <div class="form-group">
                                                <label class="form-label">{{ $t('label.duration') }}</label>
                                                <div class="input-group bg-white shadow-inset-2">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text bg-transparent border-right-0">
                                                            <i class="fas fa-clock"></i>
                                                        </span>
                                                    </div>
                                                    <vue-timepicker
                                                        class="form-control bg-transparent pt-1"
                                                        :format="'H hr mm Min'"
                                                        :hide-disabled-hours="true"
                                                        :hour-range="hourRange"
                                                        :minute-range="minuteRange"
                                                        :minute-interval="15"
                                                        v-model="duration"
                                                        @open="updateTimePicker()"
                                                        @change="updateTimePicker()">
                                                    </vue-timepicker>
                                                </div>
                                                <div id="err" class="error-validation"></div>
                                            </div>
                                        </div>
                                        <br> -->
                                        <div v-show="false" class="col-sm-12 mb-3">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" class="custom-control-input" id="outlet-duration" v-model="outletDurationToggle">
                                                <label class="custom-control-label" for="outlet-duration">Outlet Duration</label>
                                            </div>
                                        </div>
                                        <div class="col-12" v-show="outletDurationToggle">
                                            <table class="table table-clean" :style="{ width: online ? '100%' : 'auto' }">
                                                <tr>
                                                    <th class="text-center"></th>
                                                    <th class="text-center">Offline</th>
                                                    <th v-show="online" class="text-center">Online</th>
                                                </tr>
                                                <tr v-for="outlet in outlets" :key="'outlet-duration-' + outlet['id']">
                                                    <td class="align-middle">{{ outlet['city'] + (duplicateCity ? ' [' + outlet['username'] + ']' : '') }}
                                                    </td>
                                                    <td>
                                                        <div class="input-group bg-white shadow-inset-2" style="min-width: 200px">
                                                            <div class="input-group-prepend">
                                                                <span class="input-group-text bg-transparent border-right-0">
                                                                    <i class="fas fa-clock"></i>
                                                                </span>
                                                            </div>
                                                            <vue-timepicker
                                                                class="form-control bg-transparent pt-1"
                                                                :format="'H hr mm Min'"
                                                                :hide-disabled-hours="true"
                                                                :hour-range="hourRangeOffline[outlet['id']]"
                                                                :minute-range="minuteRangeOffline[outlet['id']]"
                                                                :minute-interval="15"
                                                                v-model="outletDuration[outlet['id']]['offline']"
                                                                @open="updateTimePicker(outlet['id'], 'Offline')"
                                                                @change="updateTimePicker(outlet['id'], 'Offline')">
                                                            </vue-timepicker>
                                                        </div>
                                                    </td>
                                                    <td v-show="online">
                                                        <div class="input-group bg-white shadow-inset-2" style="min-width: 200px">
                                                            <div class="input-group-prepend">
                                                                <span class="input-group-text bg-transparent border-right-0">
                                                                    <i class="fas fa-clock"></i>
                                                                </span>
                                                            </div>
                                                            <vue-timepicker
                                                                class="form-control bg-transparent pt-1"
                                                                :format="'H hr mm Min'"
                                                                :hide-disabled-hours="true"
                                                                :hour-range="hourRangeOnline[outlet['id']]"
                                                                :minute-range="minuteRangeOnline[outlet['id']]"
                                                                :minute-interval="15"
                                                                v-model="outletDuration[outlet['id']]['online']"
                                                                @open="updateTimePicker(outlet['id'], 'Online')"
                                                                @change="updateTimePicker(outlet['id'], 'Online')">
                                                            </vue-timepicker>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                            <br>
                                            <br>
                                            <br>
                                            <br>
                                        </div>
                                    </div>
                                </div>
                                <div :class="{ 'active': selectedTab == 'outlet' }" class="tab-pane mt-3">
                                    <div class="row">
                                        <div class="col-12">
                                            <table class="table table-clean" :style="{ width: 'auto' }">
                                                <tr>
                                                    <th class="text-center"></th>
                                                    <th class="text-center">View/Hide</th>
                                                    <!-- <th class="text-center">Salon Use ONLY</th> -->
                                                </tr>
                                                <tr v-for="outlet in outlets" :key="'outlet-duration-' + outlet['id']">
                                                    <td class="align-middle">{{ outlet['city'] + (duplicateCity ? ' [' + outlet['username'] + ']' : '') }}
                                                    </td>
                                                    <td class="text-center">
                                                        <a v-if="outletHidden[outlet['id']]" href="#" @click="onOutletHiddenClick($event, outlet['id'])">
                                                            <i class="fas fa-eye-slash"></i>
                                                        </a>
                                                        <a v-else href="#" @click="onOutletHiddenClick($event, outlet['id'])">
                                                            <i class="fas fa-eye" style="color: #13ca25"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div :class="{ 'active': selectedTab == 'policy' }" class="tab-pane mt-3">
                                    <div class="row">
                                        <div class="col-12">
                                            <label>Policy</label>
                                            <template>
                                                <vue-editor v-model="policy" />
                                            </template>
                                            <br>
                                            <br>
                                            <label>Terms & Condition</label>
                                            <div class="form-group">
                                                <input name="policy-line-1" type="text" class="form-control" v-model="policies[0]" />
                                            </div>
                                            <div class="form-group">
                                                <input name="policy-line-2" type="text" class="form-control" v-model="policies[1]" />
                                            </div>
                                            <div class="form-group">
                                                <input name="policy-line-3" type="text" class="form-control" v-model="policies[2]" />
                                            </div>
                                            <div class="form-group">
                                                <input name="policy-line-4" type="text" class="form-control" v-model="policies[3]" />
                                            </div>
                                            <br>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br>
                            <br>
                        </div>
                        <div class="modal-footer">
                            <div class="row w-100 no-gutters">
                                <div class="col">
                                    <button
                                        v-if="skuID"
                                        type="button"
                                        :class="enableCache ? 'btn-danger' : 'btn-primary'"
                                        class="btn border-0 btn-padding waves-effect waves-themed"
                                        @click="deleteItemConfirm">
                                        {{ (enableCache ? 'Disable' : 'Enable') }}
                                    </button>
                                </div>
                                <div class="col-auto">
                                    <button
                                        type="button"
                                        class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mr-3"
                                        @click="modalShow = false">
                                        {{ $t('button_link.cancel') }}
                                    </button>
                                </div>
                                <div class="col-auto">
                                    <button
                                        :disabled="!saveable"
                                        type="button"
                                        class="btn border-0 btn-primary btn-padding waves-effect waves-themed"
                                        @click="submitFormData">
                                        {{ $t('button_link.save') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div :class="{ 'show': modalDeleteShow }" class="modal fade">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content pt-3">
                    <div class="modal-body d-flex align-items-center">
                        Confirm {{ this.enable ? 'disable' : 'enable' }} {{ name }}?
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary waves-effect waves-themed" @click="modalDeleteShow = false">Cancel</button>
                        <button type="button" class="btn btn-primary waves-effect waves-themed" @click="deleteItem">OK</button>
                    </div>
                </div>
            </div>
        </div>

        <deleteModal ref="deleteModal" @performConfirmAction="deleteImage"></deleteModal>

        <div :class="{ 'show': modalErrorShow }" class="modal fade">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content pt-3">
                    <div class="modal-body d-flex align-items-center">
                        <i class="fas fa-2x" :class="isError ? ['fa-exclamation-circle', 'text-danger'] : ['fa-check-circle', 'text-success']"></i>
                        <p class="ml-3 mb-0" :class="isError ? ['text-danger'] : ['text-dark']">{{ errorMessage }}</p>
                    </div>
                    <div class="modal-footer">
                        <button id="modalClose" type="button" class="btn btn-primary waves-effect waves-themed"
                            @click="modalErrorShow = false">OK</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DeleteModal from './../../Delete_Modal'
import vueDropzone from "vue2-dropzone";
import { VueEditor } from "vue2-editor";
import VueTimepicker from 'vue2-timepicker'
import { setCategoryLabel, getCategoryText, getSubcategory, handleSessionExpired } from './../../../../assets/js/dashboard/dashboard'
import { convertToMin, formFormatTime, isNumber, isPositiveNumber, getMessage } from './../../../../assets/js/dashboard/utilities'

export default {
    name: 'itemForm',
    props: {
        category: { type: Array },
        subcategory: { type: Array },
        itemItemsCache: { type: Object },
    },
    components: {
        VueTimepicker, VueEditor, vueDropzone, DeleteModal
    },
    data() {
        return {
            modalShow: false,

            selectedTab: "details",
            hourRange: [],
            minuteRange: [],
            outlets: [],
            duplicateCity: false,
            categories: [],
            subCategory: [],
            subCategories: [],
            units: [],

            isSpinnerShow: true,

            typeID: 2,
            skuID: 0,
            name: "",
            nameError: '',
            nameDuplicateError: '',
            price: 0,
            priceError: '',
            basePrice: 0,
            basePriceError: '',
            selectedCategory: 0,
            duration: "",
            durationCache: '',
            enable: 1,
            enableCache: 1,
            online: 0,
            selectedSubcategory: {},
            selectedUnit: {},

            unit: '',
            ingredient: '',
            stockAlertHigh: 0,
            stockAlertLow: 0,

            saveable: false,

            showNameError: false,
            showPriceError: false,
            showBasePriceError: false,

            image: "",
            addImagePath: "",

            dzShow: false,
            imageChangePopup: false,
            dropOptions: {
                url: this.$api.API_IMAGE,
                addRemoveLinks: true,
                maxFiles: 1,
                paramName: 'filename',
                headers: {
                    token: this.$util.getSessionToken()
                }
            },

            oldPriceQueue: [],
            oldPriceCheck: null,

            outletPriceToggle: false,
            outletPrices: {},

            outletDurationToggle: false,
            outletDuration: {},

            minuteRangeOnline: {},
            hourRangeOnline: {},
            minuteRangeOffline: {},
            hourRangeOffline: {},

            outletHidden: {},

            policy: '',
            policies: [],

            modalDeleteShow: false,

            modalErrorShow: false,
            isError: true,
            errorMessage: '',
        }
    },
    watch: {
        "$i18n.locale"(val) {
            this.subCategory = this.setSubcategoryLabel(this.subCategories)

            var b = Object.assign({}, this.selectedSubcategory)
            this.selectedSubcategory = this.subCategory.filter(obj => obj.id == b.id)[0]
        },
    },
    methods: {
        isNumber(e) {
            setTimeout(this.validateForm, 100)
            return isNumber(e);
        },
        isPositiveNumber(e) {
            setTimeout(this.validateForm, 100)
            return isPositiveNumber(e);
        },
        updateTimePicker(outletID, type) {
            type = type || ''
            if (outletID) {
                this['minuteRange' + type][outletID] = []
            } else {
                this['minuteRange' + type] = []
            }

            let allowFirstSlot = false
            if (outletID && type) {
                if (this.outletDuration && this.outletDuration[outletID] && this.outletDuration[outletID][type.toLowerCase()]) {
                    let selected = this.outletDuration[outletID][type.toLowerCase()]
                    allowFirstSlot = selected.H && selected.H !== '0'
                }
            } else {
                allowFirstSlot = this.duration.H !== '0'

                for (let outlet of this.outlets) {
                    let outletID = outlet['id']
                    this.outletDuration[outletID] = this.outletDuration[outletID] || {}

                    let temp = this.outletDuration[outletID]['online'] = this.outletDuration[outletID]['online'] || {}
                    if (temp.H === this.durationCache.H && temp.mm === this.durationCache.mm) {
                        temp.H = this.duration.H
                        temp.mm = this.duration.mm
                        this.outletDuration[outletID]['online'] = JSON.parse(JSON.stringify(this.duration))
                    }

                    temp = this.outletDuration[outletID]['offline'] = this.outletDuration[outletID]['offline'] || {}
                    if (temp.H === this.durationCache.H && temp.mm === this.durationCache.mm) {
                        temp.H = this.duration.H
                        temp.mm = this.duration.mm
                        this.outletDuration[outletID]['offline'] = JSON.parse(JSON.stringify(this.duration))
                    }
                }

                this.durationCache = JSON.parse(JSON.stringify(this.duration))
            }

            for (var j = allowFirstSlot ? 0 : 1; j < 4; j++) {
                if (outletID) {
                    this['minuteRange' + type][outletID].push(j * 15)
                } else {
                    this['minuteRange' + type].push(j * 15)
                }
            }

            this.$forceUpdate()
        },
        onOutletHiddenClick(e, outletID) {
            e.preventDefault()

            this.outletHidden[outletID] = !this.outletHidden[outletID]

            this.$forceUpdate()
        },

        loadUnit() {
            this.units = []

            let $vm = this
            $vm.$axios({
                method: 'get',
                url: 'https://menu.tunai.io/business/unit',
                headers: { token: $vm.$session.get('token') },
            })
                .then((response) => {
                    for (let unit of response.data.unit) {
                        this.units.push({ unit: unit['unit'], name: unit['name'] })
                    }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },
        loadOutlet() {
            this.outlets = []

            let $vm = this
            $vm.$axios({
                method: 'get',
                url: 'https://bebusiness.tunai.io/outlet/',
                headers: { token: $vm.$session.get('token') },
            })
                .then((response) => {
                    this.duplicateCity = false

                    let cityList = []
                    for (let outlet of response.data) {
                        let outletID = outlet['outletID']

                        outlet['map'] = outlet['map'] || {}
                        outlet['loyalty'] = outlet['loyalty'] || {}

                        let location = outlet['map']['location'] || ''
                        location += location ? ', ' : ''
                        location += outlet['map']['city']
                        this.outlets.push({ id: outletID, city: location })

                        if (!cityList.includes(location)) {
                            cityList.push(location)
                        } else {
                            this.duplicateCity = true
                        }

                        this.minuteRangeOffline[outletID] = []
                        this.minuteRangeOnline[outletID] = []
                        for (var i = 1; i < 4; i++) {
                            this.minuteRange.push(i * 15);
                            this.minuteRangeOffline[outletID].push(i * 15);
                            this.minuteRangeOnline[outletID].push(i * 15);
                        }

                        this.hourRangeOffline[outletID] = []
                        this.hourRangeOnline[outletID] = []
                        for (var j = 0; j < 10; j++) {
                            this.hourRange.push(j);
                            this.hourRangeOffline[outletID].push(j);
                            this.hourRangeOnline[outletID].push(j);
                        }
                    }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },

        keydownName() {
            this.showNameError = true
            this.nameDuplicateError = ''

            this.validateForm()

            if (!this.name) {
                return
            }

            let skuID = this.itemItemsCache[this.name]
            if(!skuID || this.skuID === skuID) {
                return
            }

            for(let index=1; index<1000; index++) {
                let skuID = this.itemItemsCache[this.name + '#' + index]
                if(!skuID) {
                    this.nameDuplicateError = `Name taken. Product will be saved as: ${this.name}#${index}`
                    break
                }
            }
        },
        keydownPrice(event) {
            this.showPriceError = true

            if(this.isPositiveNumber(event)) {
                this.oldPriceQueue.push(this.price)
                return true
            }

            return false
        },
        keyupPrice(event) {
            if(this.oldPriceCheck) {
                clearTimeout(this.oldPriceCheck)
            }

            this.oldPriceCheck = setTimeout(() => {
                let oldPrice = this.oldPriceQueue.shift()
                do {
                    for (let outlet of this.outlets) {
                        let outletID = outlet['id']
                        this.outletPrices[outletID] = this.outletPrices[outletID] || {}

                        if (!this.outletPrices[outletID]['edit']) {
                            if (String(this.outletPrices[outletID]['selling']) === '' || parseFloat(this.outletPrices[outletID]['selling']) === parseFloat(oldPrice)) {
                                this.outletPrices[outletID]['selling'] = this.price
                            }
                        }
                    }

                    oldPrice = this.oldPriceQueue.shift()
                } while(oldPrice !== undefined)

                this.validateForm()
            }, 100)
        },
        keypressBasePrice(event) {
            this.showBasePriceError = true

            return this.isPositiveNumber(event)
        },
        keyupOutletPrice(outletID) {
            this.outletPrices[outletID] = this.outletPrices[outletID] || {}
            if (this.outletPrices[outletID]['selling']) {
                // this.outletPrices[outletID]['edit'] = true
            } else {
                this.outletPrices[outletID]['edit'] = false
            }
        },

        showAddModal(categoryValue, subcategoryValue) {
            this.showNameError = false
            this.showPriceError = false
            this.showBasePriceError = false
            this.nameDuplicateError = ''
            this.imageChangePopup = false

            this.selectedTab = 'details'

            this.setCategoryOptions()
            if (categoryValue !== 'all') {
                for (let category of this.categories) {
                    if (category.sectionID === categoryValue) {
                        this.selectedCategory = category
                    }
                }
            } else {
                this.selectedCategory = this.categories[0]
            }
            this.selectedCategory = this.selectedCategory || this.categories[0]

            this.defaultSubcategory = subcategoryValue
            this.filterSubCatByCategory(this.selectedCategory)

            this.skuID = null
            this.name = ''
            this.price = ''
            this.basePrice = '0'
            // this.duration = formFormatTime(15);
            // this.durationCache = formFormatTime(15);
            this.enable = true
            this.online = false
            this.image = ''
            this.addImagePath = ''

            this.outletPrices = {}
            this.outletDuration = {}
            this.outletHidden = {}

            this.outletPriceToggle = true
            this.outletDurationToggle = true
            for (let outlet of this.outlets) {
                let outletID = outlet['id']
                this.outletPrices[outletID] = this.outletPrices[outletID] || {}
                this.outletPrices[outletID]['selling'] = ''
                this.outletPrices[outletID]['selling_error'] = ''
                this.outletPrices[outletID]['maximum'] = ''
                this.outletPrices[outletID]['maximum_error'] = ''
                this.outletPrices[outletID]['minimum'] = ''
                this.outletPrices[outletID]['minimum_error'] = ''

                this.outletDuration[outletID] = this.outletDuration[outletID] || {}
                this.outletDuration[outletID]['online'] = formFormatTime(15)
                this.outletDuration[outletID]['offline'] = formFormatTime(15)

                this.outletHidden[outletID] = false
            }

            this.policy = ''
            this.policies = []

            this.dzShow = false

            this.unit = ''
            this.ingredient = ''
            this.stockAlertHigh = ''
            this.stockAlertLow = ''

            this.isSpinnerShow = false

            this.modalShow = true
        },
        async showEditModal(item) {
            this.nameDuplicateError = ''

            this.selectedTab = 'details'

            this.setCategoryOptions()

            item.folder = item.folder || {}

            this.skuID = item.skuID;
            this.name = item.name;
            this.price = parseFloat(item.price.price).toFixed(2);
            this.basePrice = parseFloat(item.price.base).toFixed(2);

            this.selectedCategory = null
            if (item.section.sectionID) {
                this.selectedCategory = this.categories.find(k => k['sectionID'] === item.section.sectionID)
            }
            if (!this.selectedCategory) {
                this.selectedCategory = this.categories.find(k => k['categoryID'] === item.misc.categoryID)
            }

            await this.filterSubCatByCategory(this.selectedCategory);

            this.selectedSubcategory = null
            if (item.folder.folderID) {
                this.selectedSubcategory = this.subcategory.find(k => k['folderID'] === item.folder.folderID)
            }
            if (!this.selectedSubcategory) {
                this.selectedSubcategory = this.subcategory.find(k => k['subcategoryID'] === item.misc.subcategoryID)
            }
            if (!this.selectedSubcategory) {
                this.selectedSubcategory = this.subCategory[0]
            }

            // this.duration = formFormatTime(parseInt(item.duration.duration));
            // this.durationCache = formFormatTime(parseInt(item.duration.duration));
            this.enable = item.status.enable;
            this.online = item.status.online == '1' ? true : false;
            this.image = item.image.image

            this.dzShow = false

            this.isSpinnerShow = true

            this.loadDetail(item.skuID)

            this.modalShow = true

            this.validateForm()
        },
        loadDetail(id) {
            this.$axios({
                method: 'get',
                url: `https://menu.tunai.io/business/sku/${id}/details`,
                headers: { token: this.$util.getSessionToken() }
            })
                .then((response) => {
                    let item = response.data.skus[0]

                    item.folder = item.folder || {}
                    item.prices = item.prices || []

                    this.skuID = item.skuID;
                    this.name = item.name;
                    this.price = parseFloat(item.price.price).toFixed(2);
                    this.basePrice = parseFloat(item.price.base).toFixed(2);
                    // this.selectedCategory = { id: item.misc.categoryID, text: getCategoryText(item.misc.categoryID, this.category) };
                    // this.selectedSubcategory = { id: item.misc.subcategoryID == "" ? "" : parseInt(item.misc.subcategoryID), text: item.misc.subcategoryID == "" ? this.$i18n.t('label.no_subCategory') : getCategoryText(item.misc.subcategoryID, this.subCategory) };
                    // this.duration = formFormatTime(parseInt(item.duration.duration));
                    this.enable = item.status.enable;
                    this.enableCache = item.status.enable
                    this.online = item.status.online == '1' ? true : false;
                    this.image = item.image.image

                    this.outletPriceToggle = item.price['prices'] && item.price['prices'].length > 0 ? true : false
                    this.outletPrices = {}
                    for (let price of item.price['prices']) {
                        let outletID = price['outletID']
                        this.outletPrices[outletID] = this.outletPrices[outletID] || {}
                        this.outletPrices[outletID]['selling'] = price['selling']
                        this.outletPrices[outletID]['selling_error'] = ''
                        this.outletPrices[outletID]['minimum'] = price['minimum']
                        this.outletPrices[outletID]['minimum_error'] = ''
                        this.outletPrices[outletID]['maximum'] = price['maximum']
                        this.outletPrices[outletID]['maximum_error'] = ''
                    }

                    // this.outletDurationToggle = item.duration['durations'] && item.duration['durations'].length > 0 ? true : false
                    // this.outletDuration = {}
                    // for (let duration of item.duration['durations']) {
                    //     let outletID = duration['outletID']
                    //     this.outletDuration[outletID] = this.outletDuration[outletID] || {}
                    //     this.outletDuration[outletID]['online'] = formFormatTime(parseInt(duration['online']))
                    //     this.outletDuration[outletID]['offline'] = formFormatTime(parseInt(duration['offline']))
                    // }

                    this.outletPriceToggle = true
                    this.outletDurationToggle = true
                    for (let outlet of this.outlets) {
                        let outletID = outlet['id']

                        if (!item.price['prices'] || item.price['prices'].length === 0) {
                            this.outletPrices[outletID] = this.outletPrices[outletID] || {}
                            this.outletPrices[outletID]['selling'] = parseFloat(item.price.price).toFixed(2);
                        }

                        // if (!item.duration['durations'] || item.duration['durations'].length === 0) {
                        //     this.outletDuration[outletID] = this.outletDuration[outletID] || {}
                        //     this.outletDuration[outletID]['online'] = formFormatTime(parseInt(item.duration.duration));
                        //     this.outletDuration[outletID]['offline'] = formFormatTime(parseInt(item.duration.duration));
                        // }
                    }

                    this.outletHidden = {}
                    for (let hidden of item.status['hiddens']) {
                        let outletID = hidden['outletID']
                        this.outletHidden[outletID] = hidden['hidden'] ? true : false
                    }

                    this.policy = item.policy.policy
                    this.policies = item.policy.policies

                    for (let outlet of this.outlets) {
                        let outletID = outlet.id
                        this.outletPrices[outletID] = this.outletPrices[outletID] || {}
                        this.outletDuration[outletID] = this.outletDuration[outletID] || {}
                        // this.outletHidden[outletID] = this.outletHidden[outletID]
                    }

                    this.unit = null
                    this.ingredient = null
                    if(item.unit.unit || item.ingredient.unit) {
                        for(let k of this.units) {
                            if(k['unit'] === item.unit.unit) {
                                this.unit = k
                            }
                            if(k['unit'] === item.ingredient.unit) {
                                this.ingredient = k
                            }

                            if((!item.unit.unit || (item.unit.unit && this.unit)) && (!item.ingredient.unit || (item.ingredient.unit && this.ingredient))) {
                                break
                            }
                        }
                    }

                    this.stockAlertHigh = item.alert.high
                    this.stockAlertLow = item.alert.low

                    this.isSpinnerShow = false
                })
                .catch((err) => {
                    console.log(err)
                    var error = err.response.data.error;
                    if (error == this.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },
        closeModal(isError) {
            if (!isError) {
                if (this.imageChangePopup) {
                    this.onItemChange()
                    this.imageChangePopup = false
                } else {
                    this.onItemAddOrEdit()
                }
            }

            // this.isSpinnerShow = true
            // this.$parent.$parent.$parent.isModalShow = false
        },

        setCategoryOptions() {
            this.categories = this.category//.slice(1, this.category.length)
            this.selectedCategory = this.categories[0]
        },
        async filterSubCatByCategory(item) {
            this.selectedCategory = item;
            // var strFilter = ''
            // if (item['categoryID'] !== -1) {
            //     strFilter += "?category=" + item.categoryID;
            // } else {
            //     strFilter += "?sectionID=" + item.sectionID;
            // }
            // this.subCategories = await getSubcategory(this, "", strFilter);
            this.subCategories = this.subcategory.filter(k => {
                if (item['sectionID'] === 'all') {
                    return true
                }

                if (k['section']['sectionID'] === item['sectionID']) {
                    return true
                }

                return false
            })

            this.subCategory = [{ folderID: '', name: 'No Folder' }].concat(this.subCategories)
            this.selectedSubcategory = this.subCategory[0]

            if (this.defaultSubcategory) {
                for (let subcategory of this.subCategory) {
                    if (subcategory['folderID'] === this.defaultSubcategory) {
                        this.selectedSubcategory = subcategory
                    }
                }
                this.defaultSubcategory = null
            }
        },
        setSubcategoryLabel(item) {
            return setCategoryLabel(this, false, this.$i18n.t('label.no_subCategory'), item)
        },
        selectSubcategory(item) {
            this.selectedSubcategory = item;
        },

        onItemChange() {
            this.$emit('onItemChange');
        },
        onItemAddOrEdit() {
            this.modalShow = false
            this.$emit('onItemAddOrEdit');
        },

        validateForm() {
            this.saveable = true
            let error = false

            this.nameError = ''
            this.priceError = ''
            this.basePriceError = ''
            for (let outlet of this.outlets) {
                let outletID = outlet['id']
                this.outletPrices[outletID] = this.outletPrices[outletID] || {}
                this.outletPrices[outletID]['selling_error'] = ''
                this.outletPrices[outletID]['maximum_error'] = ''
                this.outletPrices[outletID]['minimum_error'] = ''
            }

            if (!this.name) {
                this.nameError = 'This field is required'
                error = true
            }

            if (!this.price) {
                this.priceError = 'This field is required'
                error = true
            }

            if (parseFloat(this.price) < 0) {
                this.priceError = 'Price cannot be negative'
                error = true
            }

            if (!this.basePrice) {
                this.basePriceError = 'This field is required'
                error = true
            }

            if (parseFloat(this.basePrice) < 0) {
                this.basePriceError = 'Base price cannot be negative'
                error = true
            }

            if (parseFloat(this.basePrice) > parseFloat(this.price)) {
                this.basePriceError = 'Base price cannot be higher than item price'
                error = true
            }
            
            for (let outlet of this.outlets) {
                let outletID = outlet['id']

                let selling = parseFloat(this.outletPrices[outletID]['selling'])
                if (!isNaN(selling) && selling < 0) {
                    this.outletPrices[outletID]['selling_error'] = 'Selling price cannot be negative'
                    error = true
                }

                let minimum = parseFloat(this.outletPrices[outletID]['minimum'])
                if (!isNaN(minimum) && minimum < 0) {
                    this.outletPrices[outletID]['minimum_error'] = 'Minimum price cannot be negative'
                    error = true
                }

                let maximum = parseFloat(this.outletPrices[outletID]['maximum'])
                if (!isNaN(maximum) && maximum < 0) {
                    this.outletPrices[outletID]['maximum_error'] = 'Maximum price cannot be negative'
                    error = true
                }
            }

            if(error) {
                this.saveable = false
            }

            console.log(this.outletPrices)

            return error
        },
        submitFormData() {
            this.showNameError = true
            this.showPriceError = true
            this.showBasePriceError = true

            var data = this.setFormData()

            if(!data) {
                return
            }

            if (!this.skuID) {
                data.image = {}
                data.image.image = this.addImagePath
            }

            if (this.duration.H == "0" && this.duration.mm == "00") {
                document.getElementById('err').innerHTML = this.$i18n.t('message.error.duration');
                return
            }

            this.submitForm(data, 'save')
        },
        setFormData() {
            if (this.validateForm()) {
                this.saveable = false
                return
            }

            var duration = this.duration.H + " hr " + this.duration.mm + " Min"

            var data = {}

            data['skuID'] = this.skuID
            data['typeID'] = this.typeID

            data['name'] = this.name

            data['price'] = {}
            data['price']['price'] = this.price
            data['price']['base'] = this.basePrice

            data['duration'] = {}
            data['duration']['duration'] = convertToMin(duration)

            data['section'] = {}
            data['section']['sectionID'] = this.selectedCategory.sectionID

            data['folder'] = {}
            data['folder']['folderID'] = this.selectedSubcategory.folderID

            // data['misc'] = {}
            // data['misc']['categoryID'] = this.selectedCategory.categoryID
            // data['misc']['subcategoryID'] = this.selectedSubcategory.id == 0 ? "" : this.selectedSubcategory.id

            data['status'] = {}
            data['status']['enable'] = this.enable ? 1 : 0
            data['status']['online'] = this.online ? '1' : '0'

            data['price']['prices'] = []
            if (this.outletPriceToggle) {
                for (let outletID in this.outletPrices) {
                    let temp = this.outletPrices[outletID]

                    data['price']['prices'].push({
                        outletID: outletID,
                        selling: temp['selling'],
                        minimum: temp['minimum'],
                        maximum: temp['maximum'],
                    })
                }
            }

            // data['duration']['durations'] = []
            // if (this.outletDurationToggle) {
            //     for (let outletID in this.outletDuration) {
            //         let temp = this.outletDuration[outletID]

            //         var durationOnline = temp['online']
            //         if (temp['online'].H) {
            //             durationOnline = temp['online'].H + " hr " + temp['online'].mm + " Min"
            //         }

            //         var durationOffline = temp['offline']
            //         if (temp['offline'].H) {
            //             durationOffline = temp['offline'].H + " hr " + temp['offline'].mm + " Min"
            //         }

            //         data['duration']['durations'].push({
            //             outletID: outletID,
            //             online: convertToMin(durationOnline),
            //             offline: convertToMin(durationOffline),
            //         })
            //     }
            // }

            data['status']['hiddens'] = []
            for (let outletID in this.outletHidden) {
                let temp = this.outletHidden[outletID]

                data['status']['hiddens'].push({
                    outletID: outletID,
                    hidden: temp ? 1 : 0,
                })
            }

            data['policy'] = {}
            data['policy']['policy'] = this.policy
            data['policy']['policies'] = []
            for (let line of this.policies) {
                data['policy']['policies'].push(line || '')
            }

            if(this.unit) {
                data['unit'] = {}
                data['unit']['unit'] = this.unit.unit
            }
            if(this.ingredient) {
                data['ingredient'] = {}
                data['ingredient']['unit'] = this.ingredient.unit
            }
            data['alert'] = {}
            data['alert']['low'] = this.stockAlertLow
            data['alert']['high'] = this.stockAlertHigh

            return data
        },
        async submitForm(data, type) {
            let url
            if (this.skuID) {
                url = `https://menu.tunai.io/business/sku/${this.skuID}/update2`
            } else {
                delete data['skuID']
                url = `https://menu.tunai.io/business/sku/create`
            }

            this.$axios({
                method: 'post',
                url: url,
                headers: { token: this.$util.getSessionToken() },
                data: data,
            })
                .then((response) => {
                    if (response.status == 200) {
                        if (type === 'addimage') {
                            // this.onItemChange()
                            this.imageChangePopup = true
                            this.$parent.$parent.$parent.setModal(this, false, true, this.$i18n.t('message.success.upload'));
                            return
                        }

                        if (type === 'deleteimage') {
                            this.image = ''
                            // this.onItemChange()
                            this.imageChangePopup = true
                            this.$parent.$parent.$parent.setModal(this, false, true, this.$i18n.t('message.success.delete_image'));
                            return
                        }

                        var action = this.skuID ? this.$i18n.t('message.success.action.update') : this.$i18n.t('message.success.action.add')
                        var retData = response.data;
                        var message = "'" + data['name'] + "' " + this.$i18n.t('message.success.success', { 'action': action })

                        try {
                            if (retData['skus'][0]['name'] && data['name'] !== retData['skus'][0]['name']) {
                                message = `Name Taken<br>Your new product ${this.skuID ? 'updated' : 'added'} successfully as ${retData['skus'][0]['name']}`
                            }
                        } catch (e) {
                            console.log(e)
                        }

                        this.$parent.$parent.$parent.setModal(this, false, true, message);
                        this.modalShow = false
                    }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == this.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    } else {
                        // this.$parent.$parent.$parent.setModal(this, true, false, this.$i18n.t('message.error.system_error'));
                        this.modalErrorShow = true
                        this.errorMessage = this.$i18n.t('message.error.system_error')
                    }
                })
        },


        deleteItemConfirm() {
            this.modalDeleteShow = true
        },
        deleteItem() {
            // let url = `https://menu.tunai.io/business/sku/${this.skuID}/delete`
            let url = `https://menu.tunai.io/business/sku/${this.skuID}/update`

            this.$axios({
                method: 'post',
                url: url,
                headers: { token: this.$util.getSessionToken() },
                data: {
                    status: {
                        enable: !this.enableCache
                    }
                }
            })
                .then((response) => {
                    if (response.status == 200) {
                        var message = `Successfully ${this.enableCache ? 'disable' : 'enable'} ${this.name}`
                        this.$parent.$parent.$parent.setModal(this, false, true, message);

                        this.modalDeleteShow = false
                        this.modalShow = false
                    }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if (errData.error == this.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    } else {
                        // this.$parent.$parent.$parent.setModal(this, true, false, this.$i18n.t('message.error.system_error'));
                        this.modalErrorShow = true
                        this.errorMessage = this.$i18n.t('message.error.system_error')
                    }
                })
        },

        dropzoneAdd(file, response) {
            if (response.path == undefined) {
                this.parent.$parent.$parent.setModal(this, false, true, this.$i18n.t('message.error.upload'));
            }

            if (this.skuID) {
                var data = this.setFormData()
                data.image = {}
                data.image.image = response.path
                this.image = response.path
                this.submitForm(data, 'addimage')
                this.$refs.dropzone.removeFile(file)
            } else {
                this.addImagePath = response.path
            }
            // this.dzShow = true
        },
        dropzoneRemoved(file, error, xhr) {
            this.addImagePath = ''
        },
        handleDropzone(strClass) {
            var parent = document.getElementById("imageContainer");
            const imgs = parent.getElementsByClassName(strClass)

            var j = 0;
            if (imgs.length > 0) {
                for (var i = 0; i < imgs.length;) {
                    var img = imgs[i];
                    var link = img.parentElement;

                    if (img.classList.contains('img-thumbnail')) {
                        img.classList.remove('img-thumbnail');
                        img.classList.add('item-image');

                        link.classList.remove('m-auto');
                        link.classList.add('mr-2');
                        link.setAttribute('title', '');
                        parent.classList.add('d-flex');

                        this.dzShow = true;
                    } else {
                        img.classList.add('img-thumbnail');
                        img.classList.remove('item-image');

                        link.classList.add('m-auto');
                        link.classList.remove('mr-2');
                        link.setAttribute('title', this.$i18n.t('button_link.click_upload'));
                        parent.classList.remove('d-flex')

                        this.dzShow = false;
                    }
                    j++;
                }
            }
        },
        showDeleteImageModal() {
            var title = this.$i18n.t('header.delete_image')
            var message = this.$i18n.t('message.confirmation.delete_image')
            this.$refs.deleteModal.showModal(title, message)
        },
        deleteImage() {
            var data = this.setFormData()
            data.image = {}
            data.image.image = ''
            this.submitForm(data, 'deleteimage')
            this.$refs.deleteModal.toggleModal = false
        },
    },
    async mounted() {
        let $vm = this;
        // $vm.setCategoryOptions();

        // $vm.subCategories = await getSubcategory($vm, "", "?category=0");
        // $vm.subCategory = $vm.setSubcategoryLabel($vm.subCategories)
        // $vm.selectedSubcategory = $vm.subCategory[0]

        $vm.duration = {
            "H": "0",
            "mm": "30",
        }

        this.loadOutlet()
        this.loadUnit()
    }
}
</script>
<style scoped>
.show {
    display: block;
}

.nav-link,
.link {
    cursor: pointer;
}

.img-thumbnail {
    width: 20em;
}

.item-image {
    width: 8em;
    opacity: .5;
}

.error-validation {
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}

.form-control.error-class {
    border: 1px dotted #cc5965;
}

label.error-class {
    color: #cc5965;
    display: inline-block;
    margin-left: 5px;
}

label.info-class {
    color: #2196F3;
    display: inline-block;
    margin-left: 5px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}
</style>